import React, { useState, useEffect } from "react";
import AwaitInvite from "./AwaitInvite";
import InviteReceived from "./InviteReceived";
import getServices from "../../Services/get-service";
import Skeleton from "@mui/material/Skeleton";
import Note from "../../Assets/images/note.svg";
import { toast } from "react-toastify";

function Pendingrent() {
  const [approvedRentals, setApprovedRentals] = useState([]);
  const [pendingRentals, setPendingRentals] = useState([]);
  const [loadingApproved, setLoadingApproved] = useState(true);
  const [loadingPending, setLoadingPending] = useState(true);

  const fetchRentals = () => {
    setLoadingApproved(true);
    setLoadingPending(true);

    getServices
      .getRentalsByUserAndStatus("APPROVED")
      .then((res) => {
        if (res.data.statusCode === 200) {
          const data = res.data.data || [];
          setApprovedRentals(Array.isArray(data) ? data : []);
        }
      })
      .catch((error) => toast.error(error))
      .finally(() => setLoadingApproved(false));

    getServices
      .getRentalsByUserAndStatus("PENDING")
      .then((res) => {
        if (res.data.statusCode === 200) {
          const data = res.data.data || [];
          setPendingRentals(Array.isArray(data) ? data : []);
        }
      })
      .catch((error) => toast.error(error))
      .finally(() => setLoadingPending(false));
  };

  useEffect(() => {
    fetchRentals();
    window.addEventListener("rent-updated", fetchRentals);
    return () => window.removeEventListener("rent-updated", fetchRentals);
  }, []);

  return (
    <div>
      {loadingApproved && loadingPending ? (
        [1, 2].map((item) => (
          <div key={item} className=" my-3 border-gray-200 border rounded p-3">
            <Skeleton variant="rectangular" height={100} width="100%" />
          </div>
        ))
      ) : !loadingApproved &&
        !loadingPending &&
        approvedRentals.length === 0 &&
        pendingRentals.length === 0 ? (
        <div className="flex flex-col items-center justify-center py-10">
          <img src={Note} alt="No rentals" className="mb-4 w-16 h-16" />
          <p className="text-center text-gray-500 font-medium">
            No pending rent available
          </p>
        </div>
      ) : (
        <>
          {loadingApproved ? (
            <div className=" my-3 border-gray-200 border rounded p-3">
              <Skeleton variant="rectangular" height={100} width="100%" />
            </div>
          ) : (
            approvedRentals.map((rental, i) => (
              <InviteReceived key={`approved-${i}`} rental={rental} />
            ))
          )}
          {loadingPending ? (
            <div className=" my-3 border-gray-200 border rounded p-3">
              <Skeleton variant="rectangular" height={100} width="100%" />
            </div>
          ) : (
            pendingRentals.map((rental, i) => (
              <AwaitInvite key={`pending-${i}`} rental={rental} />
            ))
          )}
        </>
      )}
    </div>
  );
}

export default Pendingrent;
